export default {
  computed: {
    // Return all contact types
    contacts_types: function() {
      return [
        { text: 'Cellulare', value: 'cellular', icon: 'mdi-cellphone', href: 'tel' },
        { text: 'Telefono', value: 'phone', icon: 'mdi-phone', href: 'tel' },
        { text: 'Email', value: 'email', icon: 'mdi-email', href: 'mailto' },
      ];
    },
  },

  methods: {
    // Load the contact list from string
    contacts_load: function(contacts) {
      return contacts ? contacts.split('\n').map(
        (contact, index) => {
          const [contactType, contactValue] = contact.split('\t', 2);
          const contactTypeInfo = this.contacts_types.find(element => element.value === contactType);

          return {
            type: contactType,
            value: contactValue,
            index: index,
            icon: contactTypeInfo ? contactTypeInfo.icon : null,
            href: contactTypeInfo ? contactTypeInfo.href : null,
          };
        }, []
      ) : [];
    },

    // Save the given contact list as string
    contacts_save: function(contactList) {
      return contactList.map((contact) => {
        return `${contact.type}\t${contact.value}`;
      }).join('\n');
    },

  }
}
